//@flow
import React, { useState, memo } from 'react';
import Slider from 'react-slick';
import isEmpty from 'lodash/isEmpty';

import api from '../../lib/api';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { WhitePanel } from '../UI';

type GalleryArrowProps = {
  onClick: () => void,
  direction: string,
};

const GalleryArrow = ({ onClick, direction }: GalleryArrowProps) => (
  <div className={`control ${direction}`}>
    <a role="button" onClick={onClick}>
      <div className="circle">
        <i className={`icon icon-hg-chev-${direction}`} />
      </div>
    </a>
  </div>
);

const settings = toShow => ({
  infinite: false,
  slidesToShow: toShow,
  slidesToScroll: 1,
  autoplay: false,
  swipe: true,
  dots: false,
  nextArrow: <GalleryArrow direction="right" />,
  prevArrow: <GalleryArrow direction="left" />,
  responsive: [
    {
      breakpoint: 1200,
      settings: { infinite: false, slidesToShow: toShow, slidesToScroll: 1 },
    },
    {
      breakpoint: 1024,
      settings: { infinite: false, slidesToShow: toShow, slidesToScroll: 1 },
    },
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
});

const cached = new Map();

type Props = {
  title: string,
  endpoint: string,
  showNoOfCards: number,
  Card: React.ReactElement,
  keysToFilterOut?: Array<string>,
  data?: Array<Object>,
};

function CardsSlider(props: Props) {
  const { endpoint, Card, showNoOfCards, title, keysToFilterOut, data } = props;
  const [cardData, setCardData] = useState(cached.get(endpoint) || data);

  React.useEffect(() => {
    fetchFeaturedItems();
  }, []);

  React.useEffect(() => {
    setCardData(data);
  }, [data]);

  async function fetchFeaturedItems() {
    if (cardData) return;

    const { data } = await api.get(endpoint);

    setCardData(data);
    cached.set(endpoint, data);
  }

  if (isEmpty(cardData)) return null;

  function renderSlider(data) {
    return (
      <WhitePanel>
        <h2>{title}</h2>
        <Slider {...settings(showNoOfCards)} className="featured-slider">
          {data.map(l => (
            <div key={l.id} className="item">
              <Card cardData={l} />
            </div>
          ))}
        </Slider>
      </WhitePanel>
    ); 
  }

  if (keysToFilterOut) {
    const filtered = cardData.filter(l => !keysToFilterOut.includes(l.id));
    return renderSlider(filtered);
  }

  return renderSlider(cardData);
}

CardsSlider.defaultProps = {
  showNoOfCards: 5,
};

export default memo(CardsSlider);



// WEBPACK FOOTER //
// ./src/components/CardsSlider/CardsSlider.js